import { getCartDev } from './getCartDev';
import { getCartLive } from './getCartLive';

const isDev = process.env.NODE_ENV === 'development';

export const getCart = isDev ? getCartDev : getCartLive;
